/* eslint-disable @typescript-eslint/no-explicit-any */
import { STAMPS_USER_NOT_LOGGED_IN } from '../constants/stampsConstants';
import { httpServices } from './httpServices';

const { get, post } = httpServices;

function createQueryKey(key: string, params: Record<string, any>) {
  return [key, ...Object.values(params)];
}

export interface IGetStampsParams {
  categoryId: string;
  hospitalId: string;
  enabled?: boolean;
}

export interface IPostStampsParams {
  categoryId: string;
  hospitalId: string;
  year: string;
  enabled?: boolean;
}

export interface IGetStampsResponse {
  img: string;
  imgMin: string;
  year: string;
}
const getCurrentStamp = (params: IGetStampsParams) => {
  const queryKey = createQueryKey('getCurrentStamps', params);
  return get({
    key: queryKey,
    url: `${process.env.NEXT_PUBLIC_BASE_API_URL_SP}${STAMPS_USER_NOT_LOGGED_IN}categories/${params.categoryId}/hospitals/${params.hospitalId}/current`,
    params,
  });
};

const GetViewStamp = ({
  categoryId,
  hospitalId,
  enabled = false
}: IGetStampsParams) =>
  get({
    key: ['getCurrentStamps', 'view', categoryId, hospitalId],
    url: `${process.env.NEXT_PUBLIC_BASE_API_URL_SP}stamps/categories/${categoryId}/hospitals/${hospitalId}/current/view`,
    enabled
  });

const PostViewStamp = ({ categoryId, hospitalId, year }: IPostStampsParams) =>
  post({
    url: `${process.env.NEXT_PUBLIC_BASE_API_URL_SP}stamps/categories/${categoryId}/hospitals/${hospitalId}/years/${year}/view`,
    data: {
      hospitalId,
      categoryId
    }
  });

export const stampsService = {
  getCurrentStamp,
  GetViewStamp,
  PostViewStamp
};
